import { timeOffService } from "src/services/api";

const state = {
  status: {},
  statusText: "",
  errors: [],
  data: [],
  loadingTable: false,
  loadingAction: false,
};

const actions = {
  async getAll({ commit, dispatch }, params = {}) {
    commit(
      "setLoadingTable",
      params["noLoading"] ? params["noLoading"] : false
    );
    await timeOffService.getAll(params).then(
      (response) => {
        commit("setData", response.data);
        // commit("setMetaData", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async create({ commit, dispatch }, payload) {
    await timeOffService.create(payload).then(
      (response) => {
        commit("statusOk", response);
        commit("appendData", payload);
        dispatch("snackbar/success", `New request time off added`, {
          root: true,
        });
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async update({ commit, dispatch }, payload) {
    await timeOffService.update(payload).then(
      (response) => {
        commit("statusOk", response);
        dispatch("snackbar/success", `Update request time off successful`, {
          root: true,
        });
      },
      (responseError) => {
        commit("statusError", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async delete({ commit, dispatch }, payload) {

    await timeOffService.delete(payload).then(
      (response) => {
        commit("statusOk", response);
        dispatch(
          "snackbar/success",
          `Request time off "${payload.id}" deleted`,
          {
            root: true,
          }
        );
      },
      (responseError) => {
        commit("statusError", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async getById({ commit }, id) {
    await timeOffService.getById(id).then(
      (response) => {
        commit("setSingle", response);
        // dispatch(
        //   "snackbar/success",
        //   `Add user group "${payload.name}" successful`,
        //   { root: true }
        // );
      },
      (responseError) => {
        commit("statusError", responseError);
        // dispatch("alert/error", responseError, { root: true });
      }
    );
  },
  clearData({ commit }) {
    commit("setData", []);
  },
};

const mutations = {
  setData(state, data) {
    state.data = data;
  },

  appendData(state, item) {
    state.data.push(item);
  },

  setLoadingTable(state, value) {
    state.data.loadingTable = value;
  },

  updateData(state, item) {
    const index = state.data.findIndex((data) => data.id === item.id);
    console.log("found index", index);
    if (index !== -1) state.data.splice(index, 1, item);
  },

  deleteData(state, item) {
    state.data.splice(state.data.indexOf(item.id), 1);
  },

  statusError(state, response) {
    state.statusText = "create-error";
    state.status = { error: true, message: response.message };
  },

  statusOk(state, response) {
    state.statusText = "ok";
    state.status = { error: false, message: response.message };
  },
};

const getters = {
  getAll(state) {
    let data = state.data;
    return data;
  },
};

export const timeOff = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
